var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/pause-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pause-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.97748 17.5625C4.53748 17.5625 0.914978 13.9475 0.914978 9.5C0.914978 5.0525 4.53748 1.4375 8.97748 1.4375C13.4175 1.4375 17.04 5.0525 17.04 9.5C17.04 13.9475 13.425 17.5625 8.97748 17.5625ZM8.97748 2.5625C5.15248 2.5625 2.03998 5.675 2.03998 9.5C2.03998 13.325 5.15248 16.4375 8.97748 16.4375C12.8025 16.4375 15.915 13.325 15.915 9.5C15.915 5.675 12.8025 2.5625 8.97748 2.5625Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5075 12.4621H6.5325C5.8425 12.4621 5.4375 12.0646 5.4375 11.3971V7.60211C5.4375 6.93461 5.85 6.53711 6.5325 6.53711H7.5C8.19 6.53711 8.595 6.93461 8.595 7.60211V11.3971C8.6025 12.0646 8.19 12.4621 7.5075 12.4621ZM6.5625 11.3371H7.4775V7.66211H6.57L6.5625 11.3371Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.4675 12.4621H10.5C9.81003 12.4621 9.40503 12.0646 9.40503 11.3971V7.60211C9.40503 6.93461 9.81753 6.53711 10.5 6.53711H11.4675C12.1575 6.53711 12.5625 6.93461 12.5625 7.60211V11.3971C12.5625 12.0646 12.15 12.4621 11.4675 12.4621ZM10.5225 11.3371H11.4375V7.66211H10.53L10.5225 11.3371Z",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pause-icon.ad676499bf4758c4dfedd0622fe916d1.svg";
export { ForwardRef as ReactComponent };